import styled from "styled-components";

export const StyledSearchContainer = styled.div`
  display: flex;
  padding: 1rem;
`;
